import React from "react";
import { Spin, Alert } from 'antd';
import Cookies from "js-cookie";
import { useLiff } from "react-liff-v2";
import { useHistory, useParams } from "react-router-dom";
import { PATH } from "../../routes/Routes";
import LoginSegment from "../../components/common/LoginSegment";

export default function LiffLoginView(props) {
  const history = useHistory();
  const { error, liff, isLoggedIn, ready } = useLiff();
  const { app } = useParams();
  const [nextPath, setNextPath] = React.useState(PATH.LOG_WOOD_PO);

  const handleOnLoggedIn = async () => {
    history.replace(nextPath);
  };

  React.useEffect(() => {
    setNextPath(`/${app}/`);  // Manual set next route from given URL
  }, [app]);

  React.useEffect(() => {
    if (ready && isLoggedIn && Cookies.get('token') != null) {
      // Already logged in, auto redirect
      history.replace(nextPath);
    }
  }, [ready]);


  return (
    <>
      {!ready && (
        <Spin tip="Initializing Line LIFF..." size="large" />
      )}
      {ready && !isLoggedIn && (
        <Spin tip="Logging In to Line Server..." size="large">
          {liff.login()}
        </Spin>
      )}
      {ready && isLoggedIn && Cookies.get("token") == null && (
        <LoginSegment onLoggedIn={handleOnLoggedIn} liff={liff} />
      )}
      {error && (
        <Alert
          message="Error on Line LIFF"
          description={error}
          type="error"
          showIcon
          style={{ marginTop: "20px" }}
        />
      )}
    </>
  );
};
